module.exports = __webpack_public_path__ + "static/card-2782cf4c79a5c244f5ab3d9ad1f2ad71.jpg";